import { css } from '@emotion/react';
import styled from '@emotion/styled';
import React, { FC } from 'react';
import { Container } from '../container';
import { LinkTo } from '../linkTo/LinkTo';

// Interface

export interface BreadcrumbProps {
  parentPages: BreadcrumbItemProps[];
}

export interface BreadcrumbItemProps {
  url?: string;
  name: string;
}

// Styles

const StyledBreadcrumb = styled.nav`
  ${({ theme: { colors, space, maxMedia } }) => css`
    padding: ${space.xSmall} 0;
    width: 100%;

    @media (max-width: ${maxMedia.medium}) {
      padding: ${space.xxSmall} 0;
    }
  `};
`;

const StyledBreadcrumbItems = styled.ul`
  ${({ theme: { space, maxMedia, media } }) => css`
    display: flex;
    /* align-items: center; */
    column-gap: ${space.xxSmall};
    flex-wrap: wrap;

    li {
      display: flex;

      span {
        text-wrap: nowrap;
      }
      &:after {
        display: inline-block;
        padding-left: ${space.xxSmall};
        content: '\u003E';
          color: #111;
          opacity: 0.5;
      }
      


      @media (max-width: ${maxMedia.medium}) {
       * {
        font-size: 13px;
       }
      } 


   
        &:last-child {
          padding-right: 0;
          &:after {
            display: none;
          }
        }
      }
    }
  `};
`;

const StyledBreadcrumbLink = styled(LinkTo)`
  ${({ theme: { colors } }) => css`
    color: #111;
    opacity: 0.5;
    text-decoration: none;
  `};
`;

// JSX

export const Breadcrumb: FC<BreadcrumbProps> = ({ page }) => {
  const items = [...page.parentPages];
  // Push current page into the array
  items.push({ name: page?.name });
  // Rename the first Page Home
  items[0].name = 'Home';

  if (items.length <= 1) {
    return null;
  }

  return (
    <StyledBreadcrumb aria-label="Breadcrumb">
      <Container>
        <StyledBreadcrumbItems>
          {items?.length >= 1 &&
            items.map(({ url, name }, index, arr) => (
              <li key={index}>
                {arr.length - 1 === index ? (
                  <span>{name}</span>
                ) : (
                  <StyledBreadcrumbLink to={url}>{name}</StyledBreadcrumbLink>
                )}
              </li>
            ))}
        </StyledBreadcrumbItems>
      </Container>
    </StyledBreadcrumb>
  );
};

export default Breadcrumb;
